// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see LocalBlockerBuiltNudgePaymentEducationalPrerenderEvent
 */
export var LocalBlockerBuiltNudgePaymentEducationalPrerender = function (_a) {
    var flowToken = _a.flowToken, nudgePaymentToken = _a.nudgePaymentToken;
    return ({
        name: "LocalBlocker Built NudgePaymentEducationalPrerender",
        parameters: {
            cdf_entity: "LocalBlocker",
            cdf_action: "Built",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            nudge_payment_token: nudgePaymentToken !== undefined && nudgePaymentToken !== null ? nudgePaymentToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see LocalBlockerBuiltMissedCashbackEducationalPrerenderEvent
 */
export var LocalBlockerBuiltMissedCashbackEducationalPrerender = function (_a) {
    var flowToken = _a.flowToken, missedCashbackToken = _a.missedCashbackToken;
    return ({
        name: "LocalBlocker Built MissedCashbackEducationalPrerender",
        parameters: {
            cdf_entity: "LocalBlocker",
            cdf_action: "Built",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            missed_cashback_token: missedCashbackToken !== undefined && missedCashbackToken !== null ? missedCashbackToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
